import styled from 'styled-components'
import { CardElement } from '@stripe/react-stripe-js'

export const StripeCardElementContainer = styled.div`
  align-items: flex-start;
  border: 2px solid #f1f2f5;
  border-radius: 6px;
  box-sizing: border-box;
  display: flex;
  height: 45px;
  justify-content: flex-start;
  padding: 10px;
  width: 100%;
`

const CARD_ELEMENT_OPTIONS = {
  style: {
    base: {
      color: '#2B2B2B',
      fontSize: '16px',
      '::placeholder': {
        color: '#aab7c4',
      },
      'letter-spacing': '-0.6px',
      'line-height': '140%',
      'font-weight': '500',
    },
    invalid: {
      color: 'rgba(235, 87, 87, .6)',
      iconColor: 'rgba(235, 87, 87, .6)',
    },
  },
}

export const StripeCardElement: React.FC<{ onChange: () => void }> = ({
  onChange,
}) => {
  return (
    <StripeCardElementContainer>
      <CardElement options={CARD_ELEMENT_OPTIONS} onChange={onChange} />
    </StripeCardElementContainer>
  )
}
